module.exports = __webpack_public_path__ + "img/ascendant-bars-graphic.e9e18cbe.svg";